module.exports = __webpack_public_path__ + "img/photo_2023-04-27 22.02.06.e7bc308f.jpeg";